<template>
  <div class="page">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="list" v-for="(item,index) in userlist" :key="index" :title="item.name">
          <div class="item">
            <div class="item-info">
                <div>
                  <img class="item-user-img" :src="item.photo"/>
                </div>
                <div class="item-user-info">
                  <div class="user-info-realname">{{item.name}}</div>
                  <div class="user-info-signature" v-if="item.count_study_day*1">坚持学习{{item.count_study_day}}天</div>
                  <div class="user-info-signature" v-else>这家伙很懒,还没有学习</div>
                </div>
            </div>
            <div  class="item-op-zone">
              <div v-if="0" class="item-op" >关注</div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import {Image as VanImage, List, PullRefresh } from 'vant';
export default {
  name: "users",
    components:{
      [VanImage.name]:VanImage,
      [List.name]:List,
      [PullRefresh.name]:PullRefresh,
    },
    data(){
        return {
            course_id: '',
            loading: false,
            finished: false,
            refreshing: false,
            page:1,
            pageSize:10,
            userlist:[]
        }
    },
    mounted(){
        this.$(document).attr('title','参与的同学')
        this.course_id = this.util.getQueryStr('course_id');
    },
    methods:{
      init(){
        
      },
      onLoad() {
        this.getlist()
      },
      onRefresh() {
        this.page = 1
        this.userlist = []
        this.getlist()
      },
      getlist(){
        this.getCourseUsers()
      },
      getCourseUsers(){
          const _self = this
          this.util.server.mini_course.get_course_users({
              data: {
                  course_id: this.course_id,
                  page:this.page,
                  pagesize:this.pageSize
              },
              callback: (res => {
                  const { code, data, msg } = res;
                  if(_self.refreshing){
                      _self.refreshing=false;
                  }
                  if(code == 1) {
                      _self.userlist = _self.userlist.concat(data.items)
                      _self.page ++
                      _self.loading = false
                      _self.loading_list = false
                      if(_self.userlist.length >= data.total){
                          _self.finished = true;
                      }
                      
                  }else{
                      _self.util.showToast({
                          message: msg
                      });
                  }
              })
          });
      },
    }
}
</script>
<style  scoped>
.page{
  padding: 20px;
  background: #F6F8FB;
  height: 100vh;
}
.item{
  margin-bottom: 8px;
  padding: 20px 27px 20px ;
  display: flex;
  justify-content: space-between;
  background: #FFFFFF;
  border-radius: 16px;
}
.item-info{
  display: flex;
}
.item-user-img{
    width: 55px;
    height: 55px;
    border-radius: 50%;
    margin-right: 10px;
}
.item-user-info{
  display: flex;
  flex-direction: column;
}
.user-info-realname{
  line-height: 25px;
  height: 25px;
  font-size: 15px;
  color: #000000;
  font-weight: 600;
}
.user-info-signature{
  margin-top: 5px;
  color: #575758;
  line-height: 25px;
  height: 25px;
  font-size: 12px;
}
.item-op-zone{
  line-height: 50px;
  height: 50px;
}
.item-op{
  height: 25px;
  display: inline;
  background-color: #ffa500;
  color: #FFF;
  padding: 4px 8px;
  border-radius: 4px;
}

</style>